import { authService } from "@mr-portfolio-infrastructure/auth/auth-service";

import { ApiError, type ProblemDetails } from "./api-error";

/** Transport of the generated API clients: adds the access token and turns an error response into an `ApiError`. */
export const httpClient = {
  fetch(url: RequestInfo, init?: RequestInit): Promise<Response> {
    return sendRequest(url, init);
  },
};

async function sendRequest(url: RequestInfo, init?: RequestInit): Promise<Response> {
  const headers = await buildHeaders(init?.headers);

  const response = await fetch(url, { ...init, headers, credentials: "same-origin" });

  if (response.status === 401) {
    await authService.signIn(currentPath());
  }

  if (!response.ok) {
    const problemDetails = await readProblemDetails(response);

    throw new ApiError(response.status, problemDetails);
  }

  return response;
}

async function buildHeaders(requestHeaders: HeadersInit | undefined): Promise<Headers> {
  const headers = new Headers(requestHeaders);
  const accessToken = await authService.getAccessToken();

  if (accessToken !== null) {
    headers.set("Authorization", `Bearer ${accessToken}`);
  }

  return headers;
}

function currentPath(): string {
  const path = `${window.location.pathname}${window.location.search}`;

  return path;
}

async function readProblemDetails(response: Response): Promise<ProblemDetails | null> {
  const contentType = response.headers.get("Content-Type") ?? "";

  if (!contentType.includes("json")) {
    return null;
  }

  try {
    const problemDetails = (await response.json()) as ProblemDetails;

    return problemDetails;
  } catch {
    return null;
  }
}
